<template>
  <div class="not-found-container">
    <h1 class="not-found">Not Found!</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>

<style scoped>
.not-found {
  color: red;
  font-size: 2em;
}

.not-found-container {
  align-self: center;
}
</style>
